import { memo } from "react"
import styled from "styled-components"
import AccountsTable from "./AccountsTable"
import AccountsModal from "./components/AccountsModal"
import AddBalanceModal from "./components/AddBalanceModal"
import { AppState, useAppSelector } from "reducers/store"
import AddFreeTrialModal from "./components/AddFreeTrialModal"
import BlockOrActiveEnterpriseAccountModal from "./components/BlockOrActiveEnterpriseAccountModal"
import AccountDetailsModal from "./components/AccountDetailsModal/AccountDetailsModal"

const PageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  height: 100%;
`

const Accounts = () => {
  const { account } = useAppSelector((x: AppState) => x.accounts)

  return (
    <PageContainer>
      <AccountsTable />
      <AccountsModal initialData={account} />
      <AddBalanceModal />
      <AddFreeTrialModal />
      <BlockOrActiveEnterpriseAccountModal />
      <AccountDetailsModal />
    </PageContainer>
  )
}

export default memo(Accounts)
